var retryTimeout;

function startClock() {
    const defaultTimeFormat = localStorage.getItem("timeFormat");
    if (typeof jinjaVars.server_time === "number") {
        var tickers = [], ticker, tb, dc, title_clock;
        TzClock.defineLocale(jinjaVars.lang, jinjaVars.clock_locale);
        ticker = new TzClock(parseFloat(jinjaVars.server_time), jinjaVars.transitions);
        tb = new TzClock.TimeBanner(document.getElementById('cityClock'), {
            'hourtype': defaultTimeFormat,
            'locale': jinjaVars.lang
        });
        dc = new TzClock.DigitalClock(document.getElementById('currentTime'), {
            'hourtype': defaultTimeFormat,
            'locale': jinjaVars.lang
        });
        ticker.registerClockRenderer(dc);
        ticker.registerClockRenderer(tb);
        if (jinjaVars.ig === 0) {
            title_clock = new TzClock.InTitleClock({
                'hourtype': defaultTimeFormat,
                'locale': jinjaVars.lang,
                'location': jinjaVars.short_name
            });
            ticker.registerClockRenderer(title_clock);
        }
        ticker.start();
        tickers.push(ticker);

        jinjaVars.timeFormatCallback = timeFormat => {
            let i, j, n, m, tc_renderers;
            for (i= 0, j = tickers.length; i < j; i++) {
                tc_renderers = tickers[i].getClockRenderers();
                for (n = 0, m = tc_renderers.length; n < m; n++) {
                    try {
                        tc_renderers[n].updateConfig('hourtype', timeFormat);
                        tc_renderers[n].render(tickers[i].getTsTimezone());
                    } catch (e) {
                        if (!e.message.includes('updateConfig is not a function')) {
                            throw e;
                        }
                    }
                }
            }
        }

        if (typeof dataLayer !== "undefined" && !parseInt(jinjaVars.ig, 10)) {
            const elements = document.getElementsByClassName("add_event");
            const clickHandler = (e) => {
                const path = e.target.getAttribute("data-href");
                if (path) window.location.href = path;
            };

            for (const element of elements) {
                element.addEventListener("click", clickHandler);
            }
        }
    } else {
        console.info("Retrying to start clock...");
        clearTimeout(retryTimeout);
        retryTimeout = setTimeout(() => startClock(), 500);
    }
}

startClock();
